import { PromiseResultActions, Dispatch } from './types';

export default function asyncAction<A, B>(
  baseType: string,
  asyncAction: () => Promise<A>,
  associatedActions?: PromiseResultActions<A, B>,
): (dispatch: Dispatch) => Promise<A> {
  return (dispatch: Dispatch) => {
    dispatch({ type: baseType });
    if (associatedActions?.before) {
      associatedActions.before(dispatch);
    }
    return asyncAction().then(
      response => {
        dispatch({ type: `${baseType}_SUCCESS`, response });
        if (associatedActions?.then) {
          associatedActions.then(dispatch, response);
        }
        return response;
      },
      error => {
        dispatch({ type: `${baseType}_FAIL`, error });
        if (associatedActions?.error) {
          associatedActions.error(dispatch, error);
        }
        return Promise.reject(error);
      },
    );
  };
}